module.exports = __webpack_public_path__ + "static/img/iconfont.a005138.svg";